import { Link } from 'react-router-dom';

/** مسار صفحة الطلب، وتُمرَّر الباقة المختارة في الرابط لتصل معها للنموذج */
export const orderPath = (packId) => (packId ? `/order?pack=${packId}` : '/order');

/**
 * كِيكَر القسم: خطّان رفيعان يتلاشيان نحو الأطراف وأيقونة صغيرة بلا إطار.
 * الشارة الدائرية المعبّأة بحدود وظل شكلٌ مستهلك في القوالب الجاهزة —
 * الصيغة التحريرية أهدأ وتوحي بعلامة فاخرة.
 */
export function Eyebrow({ icon, iconColor = 'text-z-red', label, tone = 'light' }) {
  const line = tone === 'dark' ? 'to-white/30' : 'to-gray-300';
  const text = tone === 'dark' ? 'text-white/80' : 'text-z-navy';

  return (
    <div className="flex items-center justify-center gap-3 mb-4">
      <span className={`h-px w-10 md:w-16 bg-gradient-to-r from-transparent ${line}`} />
      <span className="flex items-center gap-2">
        {icon && <i className={`fa-solid ${icon} ${iconColor} text-[11px] md:text-xs`} />}
        <span className={`text-xs md:text-sm font-bold ${text}`}>{label}</span>
      </span>
      <span className={`h-px w-10 md:w-16 bg-gradient-to-l from-transparent ${line}`} />
    </div>
  );
}

/**
 * ترويسة موحّدة لكل قسم — كِيكَر + عنوان + سطر شرح.
 * حشو أقل على الجوال ليبقى المحتوى قريباً من أعلى الشاشة.
 */
export function SectionHeading({
  eyebrow,
  icon = 'fa-wand-magic-sparkles',
  iconColor = 'text-z-green',
  title,
  highlight,
  subtitle,
}) {
  return (
    <div className="text-center mb-8 md:mb-12">
      {eyebrow && <Eyebrow icon={icon} iconColor={iconColor} label={eyebrow} />}
      {/*
        عنوان القسم كان 2xl على الجوال مقابل عناوين البنود بحجم base — فارق
        صغير جداً، خصوصاً أن Playfair لاتيني ولا يطبَّق على العربية فيتساوى
        الخطّان. رفع الحجم يضاعف العنوان عن البنود فتظهر الهرمية من نظرة واحدة.
      */}
      <h2 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4 font-serif text-z-navy leading-snug tracking-tight">
        {title}
        {/* الكلمة المفتاحية بالأحمر — نفس أسلوب عنوان الهيرو، تشدّ العين للعنوان */}
        {highlight && <span className="text-z-red"> {highlight}</span>}
      </h2>
      {subtitle && <p className="text-sm md:text-lg text-z-gray max-w-2xl mx-auto">{subtitle}</p>}
    </div>
  );
}

/** زر الشراء الرئيسي — رابط لصفحة الطلب، موحّد الشكل في كل الموقع */
export function BuyButton({ label, packId, full = false, className = '' }) {
  return (
    <Link
      to={orderPath(packId)}
      className={`bg-z-red text-white px-8 md:px-10 py-4 font-bold text-base md:text-lg hover:bg-z-red/90 rounded-full transition-all flex items-center justify-center gap-3 shadow-lg shadow-z-red/30 ${
        full ? 'w-full' : ''
      } ${className}`}
    >
      {label} <i className="fa-solid fa-bag-shopping text-xl" />
    </Link>
  );
}

/**
 * فاصل زخرفي بين الأقسام: خطّان يتلاشيان نحو الأطراف ومعيّنة حمراء واحدة.
 *
 * كانت ثلاث معيّنات متجاورة، فحين يقع الفاصل أسفل سلايدر المنتج مباشرة تُقرأ
 * كمؤشّر صفحات السلايدر ويحاول الزائر الضغط عليها. شكل واحد لا يوحي بترقيم.
 */
export function SectionDivider() {
  return (
    <div className="bg-white" aria-hidden="true">
      <div className="container mx-auto max-w-5xl flex items-center justify-center gap-4">
        <span className="h-px flex-1 bg-gradient-to-l from-gray-300 to-transparent" />
        <span className="w-2 h-2 rotate-45 bg-z-red/70" />
        <span className="h-px flex-1 bg-gradient-to-r from-gray-300 to-transparent" />
      </div>
    </div>
  );
}

